import 'ui-core/utility/js/utils';
import resizeImages from '../../plugins/resizeImages/js/resizeImages';
export const keyCodes = {
    DOWN: 40,
    END: 35,
    HOME: 36,
    LEFT: 37,
    RIGHT: 39,
    UP: 38,
    RETURN: 13,
    SPACE: 32,
    TAB: 9,
    ESCAPE: 27,
    ENTER: 13,
    leftClick: 0,
};

UX.utils.convertToArray = nodeList => Array.prototype.slice.call(nodeList);

UX.utils.isMacChromeOrSafari = () => {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('safari') !== -1) {
        return userAgent.indexOf('macintosh') > -1;
    }
};

UX.utils.isElementEmptyOrSpaces = el => el.value === null || el.value.match(/^ *$/) !== null;

UX.utils.readFromFile = async path => {
    const file = path,
        response = await fetch(file),
        data = await response.text();

    return data;
};

UX.utils.mutationObserver = (selector, configObj, callback, params, appendChild) => {
    const element = document.querySelector(selector);

    const observer = new MutationObserver(entries => {
        if (document.contains(element) && !appendChild) {
            callback(element, params);
            observer.disconnect();
        } else if (appendChild) {
            for (const entry of entries) {
                if (entry.type === 'childList' && entry.addedNodes.length > 0) {
                    if (
                        entry.addedNodes[0].hasChildNodes() &&
                        (entry.addedNodes[0].querySelector(selector) ||
                            entry.addedNodes[0] == document.querySelector(selector))
                    ) {
                        observer.disconnect();
                        callback();
                    }
                }
            }
        }
    });

    observer.observe(document, configObj);
};

UX.utils.intersectionObserver = (selectors, configObj, callback, params) => {
    const elements = document.querySelectorAll(selectors);

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const intersecting = entry.isIntersecting;
            if (intersecting) {
                callback(entry.target, params);
            }
        });
    }, configObj);

    elements.forEach(element => {
        observer.observe(element);
    });
};

UX.utils.isInViewport = element => {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

UX.utils.getCookie = cookieName => {
    const name = cookieName + '=',
        cookieDecoded = decodeURIComponent(document.cookie),
        cookieValues = cookieDecoded.split('; ');

    let result;

    cookieValues.forEach(value => {
        if (value.indexOf(name) === 0) result = value.substring(name.length);
    });

    return result;
};

UX.utils.setCookie = (cookieName, cookieValue, cookieAttributes) => {
    let {path = '/', expireDays = '', secure = '', domain = ''} = cookieAttributes || {};

    if (expireDays) {
        let date = new Date();
        date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
        expireDays = '; expires=' + date.toUTCString();
    }

    if (path) {
        path = `; path=${path}`;
    }

    if (secure) {
        secure = '; secure';
    }

    if (domain) {
        domain = `; domain=${domain}`;
    }

    document.cookie = `${cookieName}=${cookieValue}${expireDays}${path}${domain}${secure};`;
};

UX.utils.deleteCookie = (cookieName, path) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
};

UX.utils.changeImageWidthOnLoad = (image, minRatio) => {
    window.addEventListener('load', () => {
        resizeImages(image, minRatio);

        const tocAbstractPreviews = Array.from(document.querySelectorAll(image));

        if (tocAbstractPreviews.length) {
            tocAbstractPreviews.forEach(item => {
                const image = item.querySelector('img');
                image?.addEventListener('load', () => {
                    resizeImages(item, minRatio);
                });
            });
        }
    });
};

UX.utils.menuRoleButton = () => {
    const menuitems = document.querySelectorAll('nav [role="button"]');
    function handelMenuItem(event, menuitem) {
        const {SPACE, DOWN, RETURN, ESCAPE} = keyCodes;
        const {keyCode, target} = event;
        const isMenuOpen = () => target.parentNode.classList.contains('js--open');
        const isCoolbarMenuOpen = () => target.classList.contains('js--open'); // in coolbar case , "js--open is added on the link itself"
        if (keyCode === SPACE || keyCode === DOWN || keyCode === RETURN) {
            const btnMenuItems = document.querySelectorAll(`[aria-labelledby='${target.id}'] a`);
            if (!isMenuOpen()) {
                (keyCode === DOWN && isCoolbarMenuOpen()) || menuitem.click();
                (isMenuOpen() || (isCoolbarMenuOpen() && keyCode === DOWN)) && btnMenuItems[0].focus();
            } else {
                menuitem.click();
            }
            event.preventDefault();
        }
        if (keyCode === ESCAPE && isMenuOpen()) {
            menuitem.click();
        }
    }

    function handelSubMenu(event, item) {
        item.closest('div').scrollTo(0, 0);
        const parentNode = event.target.parentNode.parentNode;
        const btnMenueItems = parentNode?.querySelectorAll('a');
        const index = Array.from(btnMenueItems)?.indexOf(event.target);
        if (event.keyCode === keyCodes.DOWN || event.keyCode === keyCodes.UP) {
            if (event.keyCode === keyCodes.DOWN && btnMenueItems[index + 1]) {
                btnMenueItems[index + 1].focus();
            } else if (event.keyCode === keyCodes.DOWN && !btnMenueItems[index + 1]) {
                btnMenueItems[0].focus();
            } else if (event.keyCode === keyCodes.UP && btnMenueItems[index - 1]) {
                btnMenueItems[index - 1].focus();
            } else if (event.keyCode === keyCodes.UP && !btnMenueItems[index - 1]) {
                btnMenueItems[btnMenueItems.length - 1].focus();
            }
            event.preventDefault();
        }
    }

    menuitems?.forEach(menuitem => {
        menuitem.addEventListener('keydown', function () {
            handelMenuItem(event, menuitem);
        });

        const submenuItems = document.querySelectorAll(`[aria-labelledby = "${menuitem.id}"] a`);
        submenuItems?.forEach(item => {
            item.addEventListener('keydown', function (event) {
                if (event.keyCode === keyCodes.ESCAPE) {
                    let toggleMenu =
                        event.target.parentNode.parentNode.parentNode.querySelector('.expandable-list__toggle');
                    !toggleMenu &&
                        (toggleMenu = event.target.closest('.coolBar__section')?.querySelector('.coolBar__ctrl'));
                    toggleMenu?.click();
                    toggleMenu?.focus();
                }
                handelSubMenu(event, item);
            });
        });
    });
};

const mathJaxWarningMsgViewer = container => {
    const missingMessageContainer = document.createElement('div');
    const missingMessageIcon = document.createElement('i');
    const missingMessage = document.createElement('span');

    missingMessageContainer?.classList.add('missingEquation__container');
    missingMessageIcon?.classList.add('missingEquation__icon', 'icon-warning');
    missingMessage?.classList.add('missingEquation__text');

    missingMessageIcon?.setAttribute('aria-hidden', true);

    missingMessage.textContent = 'Missing equation!';

    missingMessageContainer?.appendChild(missingMessageIcon);
    missingMessageContainer?.appendChild(missingMessage);

    container?.replaceWith(missingMessageContainer);
    container?.remove();
};

const mathJaxImageViewer = (container, imageLink) => {
    if (!imageLink) {
        mathJaxWarningMsgViewer(container);
    }
    const fallbackImage = document.createElement('img');

    fallbackImage?.setAttribute('src', imageLink);
    fallbackImage?.setAttribute('alt', 'mathematical equation');
    fallbackImage?.classList.add('fallback__image');

    container?.replaceWith(fallbackImage);
    container?.remove();
};

UX.utils.mathOnlyFallbackViewer = () => {
    const equationContainer = document.querySelectorAll('math:not(mjx-container math)');

    equationContainer?.forEach(container => {
        const fallbackImageLink = container?.previousElementSibling?.getAttribute('data-altimg');

        fallbackImageLink ? mathJaxImageViewer(container, fallbackImageLink) : mathJaxWarningMsgViewer(container);
    });
};

UX.utils.fallbackImageViewer = () => {
    document.querySelectorAll('mjx-container')?.forEach(container => {
        const isBroken = container?.querySelector('mjx-math')?.innerHTML?.trim() === '';
        const mathImageContainer = container?.previousElementSibling;
        const fallbackImageLink = mathImageContainer?.getAttribute('data-altimg');
        const mathJaxErrorMsg = container?.querySelector('mjx-merror');
        const mathErrorContainer = mathJaxErrorMsg?.parentNode;
        const mathContainerChildNodes = mathErrorContainer ? mathErrorContainer.childNodes : [];

        ((isBroken && fallbackImageLink) ||
            (mathJaxErrorMsg && mathContainerChildNodes.length > 1) ||
            (mathJaxErrorMsg && fallbackImageLink)) &&
            mathJaxImageViewer(container, fallbackImageLink);

        ((isBroken && !fallbackImageLink) || (mathJaxErrorMsg && mathContainerChildNodes.length === 1)) &&
            mathJaxWarningMsgViewer(container);
    });
};

UX.utils.debounce = (func, delay) => {
    let timeoutId;
    return function () {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, arguments);
        }, delay);
    };
};

UX.utils.lazyFallbackImage = () => {
    const debouncedScrollHandler = UX.utils.debounce(() => {
        UX.utils.fallbackImageViewer();
        UX.utils.centerMathjaxDots(); // temporray , until we upgrade to mathjax v4
    }, 200);
    const isLazy = document.querySelector('[name="mathjax-lazy-load"]')?.getAttribute('content') === 'true';
    if (isLazy) {
        window.addEventListener('scroll', debouncedScrollHandler);
    }
};

UX.utils.parseHtml = htmlText => {
    const parser = new DOMParser();
    return parser.parseFromString(htmlText, 'text/html');
};

const getSiblings = function (e) {
    let siblings = [];
    if (!e.parentNode) {
        return siblings;
    }
    let sibling = e.parentNode.firstChild;
    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== e) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling;
    }
    return siblings;
};

//this is a recursive function to disable the least possible nodes in the DOM tree to avoid interacting with the background content
UX.utils.disableNodes = function (node, nodesToBeDisabled = []) {
    nodesToBeDisabled.push(...getSiblings(node));
    if (node.parentElement !== document.body) {
        nodesToBeDisabled.push(...getSiblings(node.parentElement));
        node = node.parentElement;
        UX.utils.disableNodes(node, nodesToBeDisabled);
    } else {
        nodesToBeDisabled.forEach(nodeElement => {
            nodeElement.inert = true;
        });
    }

    return nodesToBeDisabled;
};

// this is fixed in mathjax v4 , it should be removed when we upgrade to v4
UX.utils.centerMathjaxDots = () => {
    const mathJaxDots = document.querySelectorAll(
        'mjx-over mjx-mo.mjx-n[data-semantic-role="overaccent"][data-semantic-type="operator"] .mjx-c307'
    );
    if (mathJaxDots.length === 0) return;
    mathJaxDots.forEach(dot => {
        const base = dot.closest('mjx-mover')?.querySelector('mjx-base');
        const target = dot.closest('mjx-over');
        if (!base || !target) return;
        target.style.paddingLeft = `${base.offsetWidth}px`;
    });
};

UX.utils.screenReaderSpeak = text => {
    let divEl = document.createElement('div');
    let id = 'speak-' + Date.now();
    divEl.setAttribute('id', id);
    divEl.setAttribute('aria-live', 'assertive');
    divEl.classList.add('visually-hidden');
    document.body.appendChild(divEl);

    setTimeout(function () {
        document.getElementById(id).innerHTML = text;
    }, 100);

    setTimeout(function () {
        document.body.removeChild(document.getElementById(id));
    }, 10000);
};
